import { MetaTopicTag } from "../interfaces";
import { TechnadoptImage } from "./technadopt-image.model";
import { ProductsService } from "../products.service";

export class ProductDetail {
  ActiveTopicCategory: string;
  AwarenessVideoThumbnail: string;
  AwarenessVideoTitle: string;
  CategoryID: string;
  CategoryName: string;
  CreateDate: Date;
  Description: string;
  Image: TechnadoptImage;
  ImageURL: string;
  CoverImage: TechnadoptImage;
  CoverImageURL?: string;
  IsActive: boolean;
  NadrusCategoryId: number;
  OneDriveFolderId: string;
  OwnerDesignation: string;
  OwnerEmail: string;
  OwnerImageURL: string;
  OwnerName: string;
  ParentCategoryID: string;
  Rating: number;
  Thumbnail: TechnadoptImage;
  ThumbnailURL: string;
  TopicOwnerUserId: string;
  OwnerIdenedi: string;
  TopicTags: any[];
  TopicTypeID: string;
  UpdateDate: Date;
  VideoURL: string;
  Website: string;
  RenderType?: string;
  YoutubeChannelID: string;
  OpenForOwnership: boolean;
  TopicStatus: string; // Draft, Pending, Published
  MetaTitle: string;
  MetaDescription: string;
  Languages?: string[];
  TopicTranslations?: {
    EN: string;
    AR: string;
    SlugEN: string;
    SlugAR: string;
    NameAR: string;
    NameEN: string;
  };
  MetaTopicTags: MetaTopicTag[] = [];
  constructor(data?: any) {
    if (!data) return;

    this.ActiveTopicCategory = data["ActiveTopicCategory"];
    this.AwarenessVideoThumbnail = data["AwarenessVideoThumbnail"];
    this.AwarenessVideoTitle = data["AwarenessVideoTitle"];
    this.CategoryID = data["CategoryID"];
    this.CategoryName = data["CategoryName"];
    this.CreateDate = new Date(data["CreateDate"]);
    this.Description = data["Description"];
    this.Image = new TechnadoptImage(data["Image"]);
    this.ImageURL = data["ImageURL"];
    this.CoverImage = data["CoverImage"];
    this.CoverImageURL = data["CoverImageURL"];
    this.IsActive = data["IsActive"];
    this.NadrusCategoryId = data["NadrusCategoryId"];
    this.OneDriveFolderId = data["OneDriveFolderId"];
    this.OwnerDesignation = data["OwnerDesignation"];
    this.OwnerEmail = data["OwnerEmail"];
    this.OwnerImageURL = data["OwnerImageURL"];
    this.OwnerName = data["OwnerName"];
    this.ParentCategoryID = data["ParentCategoryID"];
    this.Rating = data["Rating"];
    this.Thumbnail = new TechnadoptImage(data["Thumbnail"]);
    this.ThumbnailURL = data["ThumbnailURL"];
    this.TopicOwnerUserId = data["TopicOwnerUserId"];
    this.OwnerIdenedi = data["OwnerIdenedi"];
    this.TopicTags = data["TopicTags"];
    this.TopicTypeID = data["TopicTypeID"];
    this.UpdateDate = new Date(data["UpdateDate"]);
    this.VideoURL = data["VideoURL"];
    this.Website = data["Website"];
    this.YoutubeChannelID = data["YoutubeChannelID"];
    this.OpenForOwnership = data["OpenForOwnership"];
    this.TopicStatus = data["TopicStatus"] || ProductsService.TOPIC_STATUS.DRAFT; // Default to Draft if not provided
    this.MetaTopicTags = data["MetaTopicTags"];
    this.MetaTitle = data["MetaTitle"];
    this.MetaDescription = data["MetaDescription"];
    this.TopicStatus = data["TopicStatus"];
    this.Languages = data["Languages"];
    this.RenderType = data['RenderType'];
    this.TopicTranslations = data["TopicTranslations"] || {
      EN: '',
      AR: '',
      SlugEN: '',
      SlugAR: '',
      NameAR: '',
      NameEN: '',
    };
  }
}
